export const ACTIVITY_REQUEST = "ACTIVITY_REQUEST";
export const ACTIVITY_RECEIVE = "ACTIVITY_RECEIVE";
export const ACTIVITY_FAILURE = "ACTIVITY_FAILURE";
export const RESET_ACTIVITY = "RESET_ACTIVITY";
